import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeatureBlocks from "./components/FeatureBlocks";
import TrustBar from "./components/TrustBar";
import WhyBackupPower from "./components/WhyBackupPower";
import ComparisonTable from "./components/ComparisonTable";
import PowerCalculator from "./components/PowerCalculator";
import FeaturedProduct from "./components/FeaturedProduct";
import WhyTrustUs from "./components/WhyTrustUs";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import CTASection from "./components/CTASection";
import ReviewsAggregate from "./components/ReviewsAggregate";
import ShopByBrand from "./components/ShopByBrand";
import EcoFlowBanner from "./components/EcoFlowBanner";
import SystemQuiz from "./components/SystemQuiz";
import ShopSection from "./components/ShopSection";
import RecentlyViewedSection from "./components/RecentlyViewedSection";

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": ["LocalBusiness", "Store"],
      "@id": "https://ironhavensupply.com/#localbusiness",
      name: "Iron Haven Supply",
      legalName: "Furman Loomis LLC",
      taxID: "41-3937806",
      description:
        "Iron Haven Supply is a registered U.S. retailer specializing in home backup power systems — solar generators, battery backups, and whole-home standby solutions. Authorized dealer for Renogy, Nature's Generator, Rich Solar, and EcoFlow.",
      url: "https://ironhavensupply.com",
      telephone: "+1-866-605-4975",
      email: "support@ironhavensupply.com",
      logo: {
        "@type": "ImageObject",
        url: "https://ironhavensupply.com/logo.png",
        width: 300,
        height: 60,
      },
      image: "https://ironhavensupply.com/og-image.jpg",
      address: {
        "@type": "PostalAddress",
        streetAddress: "2645 Broad St",
        addressLocality: "Bethel Park",
        addressRegion: "PA",
        postalCode: "15102",
        addressCountry: "US",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: 40.3337,
        longitude: -80.0362,
      },
      areaServed: {
        "@type": "Country",
        name: "United States",
      },
      openingHoursSpecification: [
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          opens: "09:00",
          closes: "17:00",
        },
      ],
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "+1-866-605-4975",
        email: "support@ironhavensupply.com",
        contactType: "customer service",
        areaServed: "US",
        availableLanguage: "English",
      },
      priceRange: "$$",
      currenciesAccepted: "USD",
      paymentAccepted: "Credit Card, Debit Card",
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Backup Power Systems",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Product",
              name: "Renogy Solar Generators & Panels",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Product",
              name: "Nature's Generator Backup Power Systems",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Product",
              name: "Rich Solar Off-Grid Equipment",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Product",
              name: "EcoFlow Portable Power Stations",
            },
          },
        ],
      },
      sameAs: [
        "https://www.facebook.com/ironhavensupply",
        "https://www.instagram.com/ironhavensupply",
        "https://www.youtube.com/@ironhavensupply",
        "https://www.tiktok.com/@ironhavensupply",
        "https://x.com/ironhavensupply",
      ],
    },
    {
      "@type": "WebSite",
      "@id": "https://ironhavensupply.com/#website",
      url: "https://ironhavensupply.com",
      name: "Iron Haven Supply",
      alternateName: "Iron Haven Supply — Home Backup Power",
      description:
        "Curated home backup power systems — solar generators, battery backups, and whole-home standby solutions.",
      publisher: { "@id": "https://ironhavensupply.com/#localbusiness" },
      potentialAction: [
        {
          "@type": "SearchAction",
          target: "https://ironhavensupply.com/shop?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      ],
    },
    {
      "@type": "WebPage",
      "@id": "https://ironhavensupply.com/#webpage",
      url: "https://ironhavensupply.com",
      name: "Iron Haven Supply | Home Backup Power Systems — Solar & Generator Solutions",
      isPartOf: { "@id": "https://ironhavensupply.com/#website" },
      about: { "@id": "https://ironhavensupply.com/#localbusiness" },
      description:
        "Shop home backup power systems including solar generators, battery backups, and whole-home standby solutions. Free shipping & manufacturer warranty on every order.",
      breadcrumb: {
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://ironhavensupply.com",
          },
        ],
      },
    },
  ],
};

export default function Home() {
  return (
    <main className="font-sans">
      {/* LocalBusiness + WebSite + WebPage structured data for GMC */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
      <Navbar />
      <HeroSection />
      <ReviewsAggregate />
      <TrustBar />
      <FeatureBlocks />
      <ShopByBrand />
      <EcoFlowBanner />
      <SystemQuiz />
      <WhyBackupPower />
      <ComparisonTable />
      <PowerCalculator />
      <FeaturedProduct />
      <ShopSection />
      <RecentlyViewedSection />
      <WhyTrustUs />
      <Testimonials />
      <FAQ />
      <CTASection />
      <Footer />
    </main>
  );
}
